"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.READ_ON_SCROLL_NUGGETS = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Lecture = require("./entities/Lecture");

var _Spoc = require("./entities/Spoc");

var _Course = require("./entities/Course");

var _SpocRoot = require("./entities/SpocRoot");

var _HtmlNugget = _interopRequireDefault(require("./entities/nuggets/HtmlNugget"));

var _UrlNugget = _interopRequireDefault(require("./entities/nuggets/UrlNugget"));

var _DataStoreComponent2 = _interopRequireDefault(require("../common/components/DataStoreComponent/DataStoreComponent2"));

var _ThemeStore = _interopRequireDefault(require("../common/components/ThemeStore/ThemeStore2"));

var _UsageStore = _interopRequireDefault(require("../KESI2/Services/UsageService/Stores/UsageStore2"));

var _ContentStore = _interopRequireDefault(require("./Stores/ContentStore"));

var _RelevancesStore = _interopRequireDefault(require("../KESI2/Services/RelevancesService/Stores/RelevancesStore2"));

var _KesiConstants = require("./KesiConstants");

var _EventSeriesNugget = _interopRequireDefault(require("./entities/nuggets/EventSeriesNugget"));

var _EventDateNugget = _interopRequireDefault(require("./entities/nuggets/EventDateNugget"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var READ_ON_SCROLL_NUGGETS = [_HtmlNugget["default"].CLASS, _UrlNugget["default"].CLASS, _EventSeriesNugget["default"].CLASS, _EventDateNugget["default"].CLASS];
exports.READ_ON_SCROLL_NUGGETS = READ_ON_SCROLL_NUGGETS;

var Kesi2BasicComponent = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(Kesi2BasicComponent, _DataStoreComponent);

  var _super = _createSuper(Kesi2BasicComponent);

  function Kesi2BasicComponent(props, context, entityPath) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, Kesi2BasicComponent);
    _this = _super.call(this, props, context);
    var entityPathArray = entityPath ? entityPath.split(_KesiConstants.KESI_PATH_DELIMITER) : null;
    var entityId = entityPathArray && entityPathArray.length > 0 ? entityPathArray[entityPathArray.length - 1] : null;
    _this.state = (0, _assign["default"])({
      entityId: entityId,
      usageCount: null
    }, _this.filterByRelevancesStoreKeys(entityId, _this.context.relevancesStore.state));
    _this.usageIds = entityId ? [entityId] : [];
    var content = _this.context.contentStore.state.content[entityId];

    if (content && content.type === _Lecture.TYPE) {
      content.nuggetIds.forEach(function (nuggetId) {
        _this.addUsageId(nuggetId);
      });
    } else if (content && content.type === _Spoc.TYPE) {
      content.lectureIds.forEach(function (lectureId) {
        _this.addUsageId(lectureId);
      });
    } else if (content && content.type === _Course.TYPE) {
      content.spocIds.forEach(function (spocId) {
        _this.addUsageId(spocId);
      });
    } else if (content && content.type === _SpocRoot.TYPE) {
      content.spocIds.forEach(function (spocId) {
        _this.addUsageId(spocId);
      });
    }
    /*
    this.mapStoreToState(this.context.themeStore, (newState) => {
      return this.filterByStoreKeys(this.themeStoreKeys, newState)
    })
     this.mapStoreToState(this.context.contentStore, (newState) => {
      return this.filterContentByStoreKeys([entityId], newState)
    })
     this.mapStoreToState(this.context.usageStore, (newState) => {
      return this.filterByStoreKeys(this.usageStoreKeys, newState)
    })
     this.mapStoreToState(this.context.relevancesStore, (newState) => {
      return this.filterByRelevancesStoreKeys(entityId, newState)
    })
    */


    _this.mapStoreToState = function (store, newState) {
      if (store === _ThemeStore["default"] || store === _UsageStore["default"]) {
        return _this.filterByStoreKeys(store, newState);
      } else if (store === _ContentStore["default"]) {
        return _this.filterContentByStoreKeys([entityId], newState);
      } else if (store === _RelevancesStore["default"]) {
        return _this.filterByRelevancesStoreKeys(entityId, newState);
      } else {
        return (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(Kesi2BasicComponent.prototype)), "mapStoreToState", _thisSuper).call(_thisSuper, store, newState);
      }
    };

    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(Kesi2BasicComponent.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme']
    }, {
      store: _UsageStore["default"],
      keys: ['quiz']
    }, {
      store: _ContentStore["default"],
      keys: ['content']
    }, {
      store: _RelevancesStore["default"],
      keys: ['relevances']
    }]);
    return _this;
  }
  /*
  componentWillUpdate (nextProps, nextState, nextEntityId = this.state.entityId) {
    if (this.state.entityId !== nextEntityId) {
      this.usageIds = [nextEntityId]
       const content = this.context.contentStore.state.content[nextEntityId]
       if (content && content.type === lectureType) {
        content.nuggetIds.forEach((nuggetId) => {
          this.addUsageId(nuggetId)
        })
      }
      else if (content && content.type === spocType) {
        content.lectureIds.forEach((lectureId) => {
          this.addUsageId(lectureId)
        })
      }
      else if (content && content.type === spocRootType) {
        content.spocIds.forEach((spocId) => {
          this.addUsageId(spocId)
        })
      }
    }
  }
  */


  (0, _createClass2["default"])(Kesi2BasicComponent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this2 = this;

      if (prevState.entityId !== this.state.entityId) {
        this.usageIds = [this.state.entityId];
        var content = this.context.contentStore.state.content[this.state.entityId];

        if (content && content.type === _Lecture.TYPE) {
          content.nuggetIds.forEach(function (nuggetId) {
            _this2.addUsageId(nuggetId);
          });
        } else if (content && content.type === _Spoc.TYPE) {
          content.lectureIds.forEach(function (lectureId) {
            _this2.addUsageId(lectureId);
          });
        } else if (content && content.type === _Course.TYPE) {
          if (content.lectureIds) {
            content.lectureIds.forEach(function (lectureId) {
              _this2.addUsageId(lectureId);
            });
          }

          if (content.spocIds) {
            content.spocIds.forEach(function (spocId) {
              _this2.addUsageId(spocId);
            });
          }
        } else if (content && content.type === _SpocRoot.TYPE) {
          content.spocIds.forEach(function (spocId) {
            _this2.addUsageId(spocId);
          });
        }
      }
    }
  }, {
    key: "addUsageId",
    value: function addUsageId(id) {
      this.usageIds.push(id);
    }
  }, {
    key: "filterContentByStoreKeys",
    value: function filterContentByStoreKeys(storeKeys, newState) {
      if (!storeKeys) {
        return newState;
      }

      var doUpdate = false;
      var updateObj = {
        content: {}
      };

      for (var i = 0; i < storeKeys.length; i++) {
        var prop = storeKeys[i];

        if (newState.content.hasOwnProperty(prop)) {
          doUpdate = true;
          updateObj.content[prop] = newState.content[prop];
        }
      }

      return doUpdate ? updateObj : false;
    }
  }, {
    key: "filterByRelevancesStoreKeys",
    value: function filterByRelevancesStoreKeys(entityId, newState) {
      if (!entityId || !newState.relevances || !newState.currentAspect || !newState.relevances) {
        return newState;
      }

      var doUpdate = false;
      var updateObj = {
        relevances: {}
      };
      var relevances = newState.relevances[newState.currentAspect].relevances;

      if (relevances) {
        (0, _keys["default"])(relevances).forEach(function (key) {
          if (key.indexOf(entityId) >= 0) {
            doUpdate = true;
            updateObj.relevances[key] = relevances[key];
          }
        });

        if (doUpdate) {
          updateObj.relevances._default = relevances._default;
        }
      }

      return doUpdate ? updateObj : false;
    }
  }, {
    key: "filterByStoreKeys",
    value: function filterByStoreKeys(storeKeys, newState) {
      if (!storeKeys) {
        return newState;
      }

      var doUpdate = false;
      var updateObj = {};

      for (var i = 0; i < storeKeys.length; i++) {
        var prop = storeKeys[i];

        if (newState.hasOwnProperty(prop)) {
          doUpdate = true;
          updateObj[prop] = newState[prop];
        }
      }

      return doUpdate ? updateObj : false;
    } // filterUsageByStoreKeys(storeKeys, newState) {
    //
    //   let sum = 0;
    //   for (let i = 0, ii = storeKeys.length; i < ii; i++) {
    //     let prop = storeKeys[i];
    //
    //     if (newState.usages.hasOwnProperty(prop)) {
    //       if (true){ // i === 0 || !this.substractChildren){
    //         sum = newState.usages[prop];
    //       }
    //       else{
    //         sum -= newState.usages[prop];
    //       }
    //     }
    //   }
    //   sum = Math.max(0, sum);
    //   console.log('filterUsageByStoreKeys', this.state.entityId, newState, sum, storeKeys);
    //   return (this.state.usageCount !== sum) ? {usageCount: sum} : false;
    // }

  }, {
    key: "registerNuggetPosition",
    value: function registerNuggetPosition(nuggetId, nuggetType, nuggetDivId, isInSwipeNugget) {
      var repeatCount = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 3;

      if (!this.props.registerNugget) {
        return;
      }

      var div = document.getElementById(nuggetDivId);

      if (div) {
        var offsetTop = div.offsetTop;
        this.props.registerNugget(nuggetId, nuggetType, nuggetDivId, isInSwipeNugget, offsetTop);
      } // repeat because some elements might not have been loaded at the very beginning


      var self = this;

      if (repeatCount > 0) {
        setTimeout(function () {
          self.registerNuggetPosition(nuggetId, nuggetType, nuggetDivId, isInSwipeNugget, repeatCount - 1);
        }, 300);
      }
    }
  }]);
  return Kesi2BasicComponent;
}(_DataStoreComponent2["default"]);

Kesi2BasicComponent.propTypes = {
  registerNugget: _propTypes["default"].func
};
Kesi2BasicComponent.contextTypes = {
  contentStore: _propTypes["default"].object.isRequired,
  dataStore: _propTypes["default"].object.isRequired,
  relevancesStore: _propTypes["default"].object.isRequired,
  themeStore: _propTypes["default"].object.isRequired,
  usageStore: _propTypes["default"].object.isRequired
};
Kesi2BasicComponent.defaultProps = {
  registerNugget: null
};
var _default = Kesi2BasicComponent;
exports["default"] = _default;